// src/pages/Admin/StatistiquesComptabilite/components/ComptaHero.jsx

import React from "react";
import {
  FaChartLine,
  FaCreditCard,
  FaEuroSign,
  FaShoppingBag,
} from "react-icons/fa";

import {
  formatCurrency,
  formatNumber,
} from "../utils/comptaDashboardUtils";

export default function ComptaHero({
  selectedSeason,
  stats,
  loading,
  onRefresh,
}) {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="relative overflow-hidden bg-gradient-to-br from-[#013E8E] via-indigo-700 to-[#4CA82F] px-5 py-6 text-white sm:px-7">
        <div className="absolute -right-16 -top-16 h-44 w-44 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-20 -left-16 h-48 w-48 rounded-full bg-emerald-300/20 blur-3xl" />

        <div className="relative flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] ring-1 ring-white/20">
              <FaEuroSign />
              Comptabilité club
            </div>

            <h1 className="mt-4 text-2xl font-bold leading-tight sm:text-3xl">
              Statistiques de comptabilité
            </h1>

            <p className="mt-3 max-w-3xl text-sm leading-6 text-white/90">
              Suivi mobile-first des règlements d’inscription, licences,
              cotisations, réductions, Pass’Sport, moyens de paiement et achats
              boutique.
            </p>

            <div className="mt-4 inline-flex rounded-2xl bg-white/15 px-4 py-2 text-sm font-bold ring-1 ring-white/20">
              Saison {selectedSeason || "—"}
            </div>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading || !selectedSeason}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-white px-4 text-sm font-bold text-slate-900 shadow-lg shadow-black/10 transition hover:-translate-y-0.5 hover:bg-white/90 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaChartLine className={loading ? "animate-spin" : ""} />
            Actualiser
          </button>
        </div>

        <div className="relative mt-5 grid grid-cols-1 gap-2 sm:grid-cols-3">
          <div className="rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
            <div className="flex items-center gap-2 text-sm font-bold">
              <FaEuroSign />
              Total règlements
            </div>
            <p className="mt-1 text-xl font-bold">
              {loading ? "…" : formatCurrency(stats?.totalReglements)}
            </p>
          </div>

          <div className="rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
            <div className="flex items-center gap-2 text-sm font-bold">
              <FaCreditCard />
              Lignes
            </div>
            <p className="mt-1 text-xl font-bold">
              {loading ? "…" : formatNumber(stats?.nombreReglements)}
            </p>
          </div>

          <div className="rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
            <div className="flex items-center gap-2 text-sm font-bold">
              <FaShoppingBag />
              Boutique
            </div>
            <p className="mt-1 text-sm text-white/80">
              Analyse des ventes par article et par mois.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}